import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { TaxVoucherSummary } from '@pedix-workspace/utils';
import { VoucherCreationQueueItem } from '../create-voucher-modal.component';
import { ArcaVoucherType, getArcaVoucherTypeName } from '@pedix-workspace/integrations-arca';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IconLoadingComponent } from '@pedix-workspace/angular-ui-icons';
import { AlertComponent, TagComponent } from '@pedix-workspace/angular-ui-alert';

@UntilDestroy()
@Component({
  selector: 'app-create-voucher-batch-errors',
  templateUrl: './create-voucher-batch-errors.component.html',
  styleUrls: ['./create-voucher-batch-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective, AlertComponent, IconLoadingComponent, TagComponent],
})
export class CreateVoucherBatchErrorsComponent {
  readonly voucherCreationQueue = input.required<VoucherCreationQueueItem[]>();

  readonly processedVouchersCount = computed(() => {
    return this.voucherCreationQueue().filter(item => item.status !== 'pending').length;
  });
  readonly getVoucherType = (taxVoucherSummary: TaxVoucherSummary) => {
    return getArcaVoucherTypeName(taxVoucherSummary.details.type as ArcaVoucherType);
  };
  readonly getTagType = (status: 'pending' | 'success' | 'error') => {
    switch (status) {
      case 'success':
        return 'success';
      case 'error':
        return 'danger';
      case 'pending':
        return 'neutral';
    }
  };
  readonly getStatusLabel = (status: 'pending' | 'success' | 'error') => {
    switch (status) {
      case 'success':
        return 'Creado';
      case 'error':
        return 'Error';
      case 'pending':
        return 'Pendiente';
    }
  };
  readonly getFormattedOrderId = (sequenceId: number) => {
    return `#${sequenceId.toString().padStart(7, '0')}`;
  };
}
